"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "calvi-dell-umbria": {
    "7d1d1582": [{
      "hkey": "9f5f0ae0",
      "slug": "san-vito",
      "name": "San Vito",
      "primary": true,
      "skipSearch": false
    }],
    "borg-s-vito": [{
      "hkey": "9f5f0ae0",
      "slug": "san-vito",
      "name": "San Vito",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "72e5689a": [{
      "hkey": "a626841f",
      "slug": "colle-tarocco",
      "name": "Colle Tarocco",
      "primary": true,
      "skipSearch": false
    }],
    "borg-s-lorenzo": [{
      "hkey": "a626841f",
      "slug": "colle-tarocco",
      "name": "Colle Tarocco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "calvi-dell-umbria"
    }],
    "87bb02fd": [{
      "hkey": "0fc0a9ef",
      "slug": "santa-maria-maddalena-contrada-pacifici",
      "name": "Santa Maria Maddalena-Contrada Pacifici",
      "primary": true,
      "skipSearch": false
    }],
    "contr-pacifici": [{
      "hkey": "0fc0a9ef",
      "slug": "santa-maria-maddalena-contrada-pacifici",
      "name": "Santa Maria Maddalena-Contrada Pacifici",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6bbcec02": [{
      "hkey": "056efa24",
      "slug": "san-giacomo",
      "name": "San Giacomo",
      "primary": true,
      "skipSearch": false
    }],
    "contr-s-giacomo": [{
      "hkey": "056efa24",
      "slug": "san-giacomo",
      "name": "San Giacomo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "3468b17e": [{
      "hkey": "307ad4de",
      "slug": "piedicasale-piloni",
      "name": "Piedicasale-Piloni",
      "primary": true,
      "skipSearch": false
    }],
    "piloni": [{
      "hkey": "307ad4de",
      "slug": "piedicasale-piloni",
      "name": "Piedicasale-Piloni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "calvi-dell-umbria"
    }],
    "15fd2e01": [{
      "hkey": "7eb9fb1f",
      "slug": "colletarocco-san-lorenzo",
      "name": "Colletarocco-San Lorenzo",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maria-della-neve": [{
      "hkey": "7eb9fb1f",
      "slug": "colletarocco-san-lorenzo",
      "name": "Colletarocco-San Lorenzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "535064c4": [{
      "hkey": "a626841f",
      "slug": "colle-tarocco",
      "name": "Colle Tarocco",
      "primary": true,
      "skipSearch": false
    }],
    "voc-colletarocco": [{
      "hkey": "a626841f",
      "slug": "colle-tarocco",
      "name": "Colle Tarocco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "37d08588": [{
      "hkey": "fa042646",
      "slug": "calvi-dell-umbria",
      "name": "Calvi dell'Umbria",
      "primary": true,
      "skipSearch": false
    }],
    "voc-forca": [{
      "hkey": "fa042646",
      "slug": "calvi-dell-umbria",
      "name": "Calvi dell'Umbria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cb9a27a7": [{
      "hkey": "ccac86b9",
      "slug": "la-corte-san-francesco-san-silvestro",
      "name": "La Corte-San Francesco-San Silvestro",
      "primary": true,
      "skipSearch": false
    }],
    "voc-la-corte-voc-s-silvestro": [{
      "hkey": "ccac86b9",
      "slug": "la-corte-san-francesco-san-silvestro",
      "name": "La Corte-San Francesco-San Silvestro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b4fa6eae": [{
      "hkey": "307ad4de",
      "slug": "piedicasale-piloni",
      "name": "Piedicasale-Piloni",
      "primary": true,
      "skipSearch": false
    }],
    "voc-piedicasale": [{
      "hkey": "307ad4de",
      "slug": "piedicasale-piloni",
      "name": "Piedicasale-Piloni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e67e9dff": [{
      "hkey": "fa042646",
      "slug": "calvi-dell-umbria",
      "name": "Calvi dell'Umbria",
      "primary": true,
      "skipSearch": false
    }],
    "voc-s-francesco": [{
      "hkey": "fa042646",
      "slug": "calvi-dell-umbria",
      "name": "Calvi dell'Umbria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5fbc9a26": [{
      "hkey": "0fc0a9ef",
      "slug": "santa-maria-maddalena-contrada-pacifici",
      "name": "Santa Maria Maddalena-Contrada Pacifici",
      "primary": true,
      "skipSearch": false
    }],
    "contrada-pacifici": [{
      "hkey": "0fc0a9ef",
      "slug": "santa-maria-maddalena-contrada-pacifici",
      "name": "Santa Maria Maddalena-Contrada Pacifici",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;